import { API_CALL } from '../../../../middleware/api';

export const BULK_UPLOAD_LIST = 'bulk-upload-list';
export const BULK_UPLOAD_LIST_RESULT = `${BULK_UPLOAD_LIST}/result`;

export const BULK_UPLOAD_GET_URL = 'bulk-upload-get-url';
export const BULK_UPLOAD_GET_URL_RESULT = `${BULK_UPLOAD_GET_URL}/result`;

export const UPLOAD_FILE = 'bulk-upload-upload-file';
export const UPLOAD_FILE_RESULT = `${UPLOAD_FILE}/result`;

export const BULK_UPLOAD_DELETE = 'bulk-upload-delete';
export const BULK_UPLOAD_DELETE_RESULT = `${BULK_UPLOAD_DELETE}/result`;


export const BULK_UPLOAD_GET_SHEET_DETAIL = 'bulk-upload-get-sheet-detail';
export const BULK_UPLOAD_GET_SHEET_DETAIL_RESULT = `${BULK_UPLOAD_GET_SHEET_DETAIL}/result`;

export const BULK_UPLOAD_GET_SHEET_ROWS = 'bulk-upload-get-sheet-rows';
export const BULK_UPLOAD_GET_SHEET_ROWS_RESULT = `${BULK_UPLOAD_GET_SHEET_ROWS}/result`;

export const BULK_UPLOAD_UPDATE_SHEET = 'bulk-upload-update-sheet';
export const BULK_UPLOAD_UPDATE_SHEET_RESULT = `${BULK_UPLOAD_UPDATE_SHEET}/result`;

export const BULK_UPLOAD_GET_UPLOAD = 'bulk-upload-get-upload';
export const BULK_UPLOAD_GET_UPLOAD_RESULT = `${BULK_UPLOAD_GET_UPLOAD}/result`;

export const BULK_UPLOAD_GET_SHEET_PATIENTS = 'bulk-upload-get-sheet-patients';
export const BULK_UPLOAD_GET_SHEET_PATIENTS_RESULT = `${BULK_UPLOAD_GET_SHEET_PATIENTS}/result`;

export const BULK_UPLOAD_GET_SHEET_PATIENT_SUMMARY = 'bulk-upload-get-sheet-patient-summary';
export const BULK_UPLOAD_GET_SHEET_PATIENT_SUMMARY_RESULT = `${BULK_UPLOAD_GET_SHEET_PATIENT_SUMMARY}/result`;

export const BULK_UPLOAD_DECIDE_SHEET_PATIENTS = 'bulk-upload-decide-sheet-patients';
export const BULK_UPLOAD_DECIDE_SHEET_PATIENTS_RESULT = `${BULK_UPLOAD_DECIDE_SHEET_PATIENTS}/result`;

export const BULK_UPLOAD_GET_CANDIDATE_MATCHES = 'bulk-upload-get-candidate-matches';
export const BULK_UPLOAD_GET_CANDIDATE_MATCHES_RESULT = `${BULK_UPLOAD_GET_CANDIDATE_MATCHES}/result`;

export const BULK_UPLOAD_CHOOSE_CANDIDATE_MATCH = 'bulk-upload-choose-candidate-match';
export const BULK_UPLOAD_CHOOSE_CANDIDATE_MATCH_RESULT = `${BULK_UPLOAD_CHOOSE_CANDIDATE_MATCH}/result`;

export const BULK_UPLOAD_RETRY_CANDIDATE = 'bulk-upload-retry-candidate';
export const BULK_UPLOAD_RETRY_CANDIDATE_RESULT = `${BULK_UPLOAD_RETRY_CANDIDATE}/result`;

const bulkUploadActions = {
  listUploads: params => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/list`,
      method: 'get',
      params,
    },
    type: BULK_UPLOAD_LIST,
  }),
  uploadFileTest: (org_uuid, formData) => ({
    [API_CALL]: {
      endpoint: `portal/${org_uuid}/bulk_upload_service/upload`,
      method: 'post',
      data: formData,
    },
    type: UPLOAD_FILE,
  }),
  getUploadUrl: (data) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/upload-url`,
      method: 'post',
      data,
    },
    type: BULK_UPLOAD_GET_URL,
  }),
  deleteFile: (org_uuid, file_uuid) => ({
    [API_CALL]: {
      endpoint: `portal/${org_uuid}/bulk_upload_service/delete/${file_uuid}`,
      method: 'delete',
    },
    type: BULK_UPLOAD_DELETE,
  }),
  getSheetDetail: (sheetId) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}`,
      method: 'get',
    },
    type: BULK_UPLOAD_GET_SHEET_DETAIL,
  }),
  getSheetRows: (sheetId, params) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}/rows`,
      method: 'get',
      params,
    },
    type: BULK_UPLOAD_GET_SHEET_ROWS,
  }),
  updateSheet: (sheetId, data) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}`,
      method: 'put',
      data,
    },
    type: BULK_UPLOAD_UPDATE_SHEET,
  }),
  getUpload: uploadUuid => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/uploads/${uploadUuid}`,
      method: 'get',
    },
    type: BULK_UPLOAD_GET_UPLOAD,
  }),
  getSheetPatients: (sheetId, params) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}/patients`,
      method: 'get',
      params,
    },
    type: BULK_UPLOAD_GET_SHEET_PATIENTS,
  }),
  getSheetPatientSummary: (sheetId) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}/patients/summary`,
      method: 'get',
    },
    type: BULK_UPLOAD_GET_SHEET_PATIENT_SUMMARY,
  }),
  // data: { decision: 'accept' | 'reject', candidate_ids: [...] } or { decision, filter: { action, tier } }
  decideSheetPatients: (sheetId, data) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}/patients/decision`,
      method: 'post',
      data,
    },
    type: BULK_UPLOAD_DECIDE_SHEET_PATIENTS,
  }),
  // What each source (our patients, athenaOne) found for one candidate.
  getCandidateMatches: (sheetId, candidateId) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}/patients/${candidateId}/matches`,
      method: 'get',
    },
    type: BULK_UPLOAD_GET_CANDIDATE_MATCHES,
  }),
  // data: { source: 'local' | 'athena', record_key } to pick a record, or { source, none: true }
  // for none of them (local: a new patient; athena: not in athenaOne).
  chooseCandidateMatch: (sheetId, candidateId, data) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}/patients/${candidateId}/choose`,
      method: 'post',
      data,
    },
    type: BULK_UPLOAD_CHOOSE_CANDIDATE_MATCH,
  }),
  // Sends a candidate back to every source (after fixing what its error reported, or to ask a
  // source that was unavailable again).
  retryCandidate: (sheetId, candidateId) => ({
    [API_CALL]: {
      endpoint: `portal/bulk_upload_service/sheets/${sheetId}/patients/${candidateId}/retry`,
      method: 'post',
      data: {},
    },
    type: BULK_UPLOAD_RETRY_CANDIDATE,
  }),
};

export default bulkUploadActions;